import {
  Applicant,
  ApplicantAddressType,
  ApplicationProps,
  Document,
  JointholderRelationMaster,
  RiskProfileMaster,
  RiskProfileMasterType,
  coparcenersType,
  individuals_Poa_nonIndividuals_Documents,
  visiblityAccessTypes,
} from '../redux-store/types/api-types';
import {
  AADHAAR_OR_SSN_MASTER,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  applicantStatusMasters,
  APPLICATION_LISTING_STATUS,
  APPLICATION_TYPE,
  APPLICATION_TYPE_FOR_DOCUMENTS,
  ApplicationStatusBasedOnRole,
  BloodRelations,
  CKYC_SELECTION_OPTIONS_OBJECT,
  CurrencyMaster,
  defaultCurrency,
  DLCLMasters,
  ENABLE_RTA_APPROVER,
  IndividualApplicationStatusBasedOnRole,
  isNaturalParent,
  MODE_OF_PAYMENT_MASTER,
  onboardingTypeMasters,
  PAN_AADHAAR_MASTER,
  PASSPORT_OR_OCI_MASTER,
  RiskProfileEnabled,
  SALT,
  SALT2,
  SIP_MASTER,
  SOURCE_OF_FUNDS_MASTER,
  UboCategoryMaster,
  UboTypeMaster,
  USER_ROLES,
  WishToUploadRiskProfileEnabled,
  YES_NO_MASTER,
  dlclIdFieldValidationDate,
  DematDetialsValidationModified,
  NRI_DECLARATION_COUNTRIES,
  nriDeclarationStartDate,
  changeGrossAnnualMastersDate,
  oldGrossAnnualMasters,
  newGrossAnnualMasters,
  directInvestmentDisabledDate,
  investorTypeMasters,
  partnershipFirmLabelChangeDate,
  FEE_TYPE_MASTER,
} from './constant';
import { ToWords } from 'to-words';
import { individualPanRegex, nonIndividualPanRegex, numberRegex } from './regex';
import _ from 'lodash';
import { mdmsCountriesList } from '../redux-store/types/mdms';
import { updatedRiskProfile } from '../components/investors/riskProfileDetails';
import { Values } from '../components/NonIndividualInvestor/ContributorDetails';
import { checkSip } from '../components/FundsSetup/addFund';
import { documentProps, document_object } from '../components/investors/documentDetails';
import en from '../lang/en-us';

export const maskMobileNumber = (mobileNumber: string): string => {
  if (!mobileNumber) {
    return '';
  }
  return (
    mobileNumber.slice(0, 2) +
    mobileNumber.slice(2, mobileNumber.length - 2).replace(/\d/g, '*') +
    mobileNumber.slice(mobileNumber.length - 2)
  );
};

export const changeGoalVal = (
  ans: string,
  riskProfileData: updatedRiskProfile[],
  question: string
) => {
  const ansArray = ans.split('*').map((val) => {
    const index = val.indexOf('_');
    const result = val.substring(0, index);
    return result;
  });
  const valueArray = riskProfileData.find((profile) => profile?.question === question)?.values;
  const labelsArray = ansArray.map((key) => {
    const item = valueArray?.find((val) => val.key === key);
    return item ? `${item.label}` : key;
  });
  return labelsArray;
};

export const getApplicantName = (index: number, isNomineeOrBank?: boolean): string => {
  if (index === 1) {
    return isNomineeOrBank ? 'First' : 'First/Sole';
  } else if (index === 2) {
    return 'Second';
  } else {
    return 'Third';
  }
};

export const minDateForContributor = (): Date => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 18);
  return date;
};

export const getFirstHolderName = (applicants: Partial<Applicant>[]): string => {
  return (
    applicants.find((applicant) => ['firstapplicant', '1'].includes(applicant.applicant_type || ''))
      ?.name || 'N/A'
  );
};

export const getApplicantType = (applicantType: string | undefined): string => {
  if (applicantType) {
    if (['firstapplicant', '1'].includes(applicantType)) {
      return '1';
    } else if (['secondapplicant', '2'].includes(applicantType)) {
      return '2';
    } else {
      return '3';
    }
  }
  return '';
};

export const formatToIndianCurrency = (value: number | null): string => {
  const options = { style: 'currency', currency: 'INR' };
  if (value) {
    return new Intl.NumberFormat('en-IN', options).format(value);
  }
  return '';
};

export function toExactSubstr(str: string): string {
  const a = str.split('.');
  if (a.length == 2) {
    return a[0]?.concat('.', a[1].substr(0, 2));
  }
  return str;
}

export const formatCurrency = (value?: number | null): string => {
  const formats = ['K', 'L', 'Cr'];
  let amount: any = Number(value);
  formats.some((key, i) => {
    const size = Math.pow(10, i === 0 ? 3 : 3 - 1);
    if (size <= amount) {
      amount = toExactSubstr(`${amount / size}`);
      if (amount >= 100 && i < formats.length - 1) {
        i++;
      } else {
        // amount = (amount * decPlaces) / decPlaces;
        amount += ' ' + formats[i];
        return true;
      }
    } else {
      return true;
    }
  });
  return amount;
};

export const EIGHTEEN_YEARS_IN_MILLISECONDS = 18 * 31556926 * 1000; //  18 * no of seconds in a Year * 1000

export const isMinor = (dateOfBirth = ''): boolean => {
  return new Date().getTime() - new Date(dateOfBirth).getTime() < EIGHTEEN_YEARS_IN_MILLISECONDS;
};

// eslint-disable-next-line @typescript-eslint/no-var-requires
const countryCodes = require('country-codes-list');
export const getCountryCodes = (): { label: string; key: string; countryCode: string }[] => {
  const countryCodesObject: { [key: string]: string } = countryCodes.customList(
    'countryCode',
    '{countryNameEn}: +{countryCallingCode}'
  );

  const modifiedCodes = Object.keys(countryCodesObject).map((cc) => ({
    label: countryCodesObject[cc],
    key: countryCodesObject[cc].split(':')[1].trim(),
    countryCode: cc,
  }));
  return modifiedCodes;
};

export const getAddressFields = (addressType: string): ApplicantAddressType => {
  return {
    address1: '',
    address2: '',
    // address3: '',
    city: '',
    state: '',
    country: addressType === 'overseas' ? '' : 'INDIA',
    pincode: '',
    permanentAddressSameAsCorresponding: false,
    address_type: addressType,
    isActive: true,
    fetchedFromKRA: null,
    preferredCommAddress: false,
  };
};

export const getAddressData = (
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  return (
    addresses?.find((address) => address.address_type === addressType) ||
    getAddressFields(addressType)
  );
};

export function getRelation(relationValue?: string | null): boolean {
  return ['Mother', 'Father', 'Daughter', 'Son', 'Spouse', 'Brother', 'Sister', ''].includes(
    relationValue || ''
  );
}

export const saveForLater = (
  role: string,
  id?: string,
  applicant1ReferenceId?: string | null
): string => {
  return role === USER_ROLES.INVESTOR
    ? `/investment-details/${applicant1ReferenceId}/application-details`
    : role === USER_ROLES.POAAPPROVER || role === USER_ROLES.AMCAPPROVER
    ? `/application-details/${id}`
    : '/applications';
};

export const maxAge = (dateOfBirth = ''): boolean => {
  const thisYear = new Date().getFullYear();
  return thisYear - new Date(dateOfBirth).getFullYear() > 125;
};
export const futureAge = (dateOfBirth = ''): boolean => {
  return new Date(dateOfBirth) > new Date();
};
export function currencyConversion(
  num?: string | number | null,
  currencyType?: string | null
): string | null {
  if (!num) return '';
  const toWords = new ToWords({
    localeCode: Object.keys(CurrencyMaster).includes(currencyType?.toLowerCase() || '')
      ? CurrencyMaster[currencyType?.toLowerCase() || defaultCurrency]?.localeCode
      : CurrencyMaster[defaultCurrency]?.localeCode,
  });
  const words = toWords.convert(Number(num), { currency: true });
  return words;
}

export const isOnboardingTypeMinor = (onBoardingType: string): boolean => {
  return onboardingTypeMasters[onBoardingType] === onboardingTypeMasters.minor;
};

export const isFatherMother = (guardianRelationship: string): boolean => {
  return ['MOTHER', 'FATHER'].includes(guardianRelationship);
};

export function checkIfApplicationIsNonIndividual({ applicationType }: ApplicationProps): boolean {
  return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL;
}

// eslint-disable-next-line
export const preventSpecialCharacters = (e: any): void => {
  if (
    !((e.ctrlKey || e.metaKey) && e.keyCode == 67) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 86) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 88) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 90) &&
    !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter', 'Tab'].includes(e.key) &&
    !numberRegex.test(e.key)
  ) {
    e.preventDefault();
  }
};
export function allowOnlyNumbers(e: any): void {
  if (['-', '+', 'e', 'E'].includes(e.key)) {
    e.preventDefault();
  }
}
export const permanentAddressSameAsCorresponding = (
  updatedCorrespondingAddress: Partial<ApplicantAddressType>,
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  // eslint-disable-next-line
  const { address1, address2, city, pincode, state, country, ...rest } =
    updatedCorrespondingAddress;
  return {
    ...getAddressData(addressType, addresses),
    address1: address1,
    address2: address2,
    city: city,
    pincode: pincode,
    state: state,
    country: country,
    address_type: addressType,
  };
};
export const _updatedAddresses = (
  updatedAddresses: {
    nationality?: string | null | undefined;
    status?: string | null | undefined;
    permanent?: Partial<ApplicantAddressType> | undefined;
    correspondence?: Partial<ApplicantAddressType> | undefined;
    overseas?: Partial<ApplicantAddressType> | undefined;
    [key: string]: string | Partial<ApplicantAddressType> | null | undefined;
  },
  applicant: Partial<Applicant>
): Partial<ApplicantAddressType>[] => {
  // eslint-disable-next-line
  const { nationality, status, ...addressProps } = updatedAddresses;
  return Object.keys(addressProps)
    .map((addressType) => {
      // if (applicant.nationality?.toLowerCase() === 'indian' && addressType === 'overseas') {
      //   return {};
      // }
      if (
        addressType === 'permanent' &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['overseas'],
          addressType,
          applicant.addresses
        );
      }
      if (
        addressType === 'permanent' &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding &&
        !addressProps['overseas']
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['correspondence'],
          addressType,
          applicant.addresses
        );
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['overseas'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['correspondence'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      return {
        ...getAddressData(addressType, applicant.addresses),
        ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
        address_type: addressType,
      };
    })
    .flat()
    .filter((address) => Object.keys(address).length);
};
export const applyRoleBasedStatus = (role: USER_ROLES): boolean => {
  return [
    USER_ROLES.RM,
    USER_ROLES.SUBDISTRIBUTOR,
    USER_ROLES.DISTRIBUTOR,
    USER_ROLES.AMCAPPROVER,
  ].includes(role);
};

export const checkKraBasedOnStatus = (status: any): boolean => {
  return ![
    APPLICATION_LISTING_STATUS.invitationexpired,
    APPLICATION_LISTING_STATUS.signed,
    APPLICATION_LISTING_STATUS.completed,
    APPLICATION_LISTING_STATUS.rejected,
  ].includes(APPLICATION_LISTING_STATUS[status]);
};

export const applicationComparison = (
  existingApplication: Partial<ApplicationProps> | null,
  updatedApplication: Partial<ApplicationProps>
): boolean => {
  return _.isEqual(existingApplication, updatedApplication);
};

export const sendApplication_Nri = (application?: ApplicationProps | null): boolean | undefined => {
  return application?.applicants.map((applicant) => applicant.status).includes('NRI');
};

export const checkForCorrespondenceAddress = (
  nationality: string | null | undefined,
  status: string | null | undefined
): boolean => {
  return (
    nationality?.toLowerCase() === 'indian' &&
    applicantStatusMasters[status as string] === applicantStatusMasters.Individual
  );
};

export const isHufType = (applicants: Partial<Applicant>[]) => {
  const investorType = applicants.find(
    (applicant) => applicant.applicant_type?.toString() === '1'
  )?.investorType;
  return ['huf', 'huf_nri'].includes(investorType || '');
};

export const setUpFeeCalculations = (
  commitmentAmount: number,
  setupFeePercentage: number
): { feeAmount: number; feeGst: number; totalSetupFee: number } => {
  const setupFeeAmount = (Number(commitmentAmount) * Number(setupFeePercentage)) / 100;
  const GstForSetupFee = (setupFeeAmount * 18) / 100;
  return {
    feeAmount: Number(setupFeeAmount),
    feeGst: 0,
    totalSetupFee: 0,
  };
};

export const checkAddressField = (data?: string): string => {
  if (data) {
    if (data.includes(' ,')) {
      return data.split(' ,').join(',') + ' ';
    }
    return data.includes(',') ? data + ' ' : data + ', ';
  }
  return '';
};

export const getdpIdField = (value: string): boolean => {
  return (
    DLCLMasters[value || ''] === DLCLMasters.cdsl || DLCLMasters[value || ''] === DLCLMasters.nsdl
  );
};

export const clearclIdField = (value: string, createdAt: string): boolean => {
  return (
    DLCLMasters[(value as string) || ''] === DLCLMasters.none ||
    (!checkValidationBasedOnDate(createdAt, DematDetialsValidationModified) &&
      DLCLMasters[(value as string) || ''] === DLCLMasters.cdsl)
  );
};

export const cleardpIdField = (value: string): boolean => {
  return DLCLMasters[(value as string) || ''] === DLCLMasters.none;
};

export const getclIdField = (value: string, createdAt: string): boolean => {
  return (
    (checkValidationBasedOnDate(createdAt, DematDetialsValidationModified) &&
      DLCLMasters[value || ''] === DLCLMasters.cdsl) ||
    DLCLMasters[value || ''] === DLCLMasters.nsdl
  );
};

export const isCDSL = (value: string): boolean => {
  return DLCLMasters[(value as string) || ''] === DLCLMasters.cdsl;
};

export const getBankAddress = (
  address1: string | undefined,
  address2: string | undefined,
  address3: string | undefined
): string => {
  return `${address2 ? checkAddressField(address1) || '' : address1 || '' || ''}${
    address3 ? checkAddressField(address2) || '' : address2 || ''
  }${address3 || ''}`;
};

export const numToAlpMonth = (numMonth: any, month: any) => {
  numMonth?.map((monthNum: any) => {
    if (monthNum === 1) {
      month.push('Jan');
    } else if (monthNum === 2) {
      month.push('Feb');
    } else if (monthNum === 3) {
      month.push('Mar');
    } else if (monthNum === 4) {
      month.push('Apr');
    } else if (monthNum === 5) {
      month.push('May');
    } else if (monthNum === 6) {
      month.push('Jun');
    } else if (monthNum === 7) {
      month.push('Jul');
    } else if (monthNum === 8) {
      month.push('Aug');
    } else if (monthNum === 9) {
      month.push('Sep');
    } else if (monthNum === 10) {
      month.push('Oct');
    } else if (monthNum === 11) {
      month.push('Nov');
    } else if (monthNum === 12) {
      month.push('Dec');
    }
  });
};

export const removeSingleQuote = (value: string | null | undefined): any => {
  if (value && value.includes("'")) return value.split("'").join('');
  else return value;
};

export function removeEqualOperator(value = ''): string {
  const lastTwoIndex = value.length - 2;
  let encodeString = value.slice(0, lastTwoIndex);
  const slicedStr = value.slice(lastTwoIndex, value.length);
  slicedStr.split('').forEach((char) => {
    if (char !== '=') {
      encodeString += char;
    }
  });
  return encodeString;
}

export function encodeBase64(value: string): string {
  const encodeValue = btoa(value);
  const encodeSubString = removeEqualOperator(encodeValue);
  const encodePayload = btoa(`${SALT}${encodeSubString}${SALT2}`);
  return encodePayload;
}

export function getNomineeRelation(relationValue?: string | null): boolean {
  return ['MOTHER', 'FATHER', 'DAUGHTER', 'SON', 'SPOUSE', 'BROTHER', 'SISTER', ''].includes(
    relationValue || ''
  );
}

export function updatedCommitmentAmount(
  minCommitmentAmount: number,
  applicants: Partial<Applicant>[],
  data: JointholderRelationMaster
): number | void {
  if (applicants.length === 2) {
    const applicantRelation = applicants
      .map((applicant) => applicant.relationShipWithFirstApplicant)
      .filter((ele) => ele)
      ?.toString();
    const relation = BloodRelations.includes(applicantRelation) ? applicantRelation : 'Others';
    const amount = data.singleJointHolder
      .map((jointHolder) => {
        if (jointHolder.jointHolder1RelationShip === relation) {
          return (minCommitmentAmount * jointHolder.minimumAmountPercentage) / 100;
        }
      })
      .filter((ele) => ele)
      .toString();
    return Number(amount);
  }
  if (applicants.length === 3) {
    const applicantRelation = applicants
      .map((applicant) => applicant.relationShipWithFirstApplicant)
      .filter((ele) => ele);
    const relation = applicantRelation.map((_relation) =>
      BloodRelations.includes(_relation as string) ? _relation : 'Others'
    );
    const amount = data.twoJointHolders
      .map((jointHolder) => {
        if (
          relation[applicants.length - 3] === jointHolder.jointHolder1RelationShip &&
          relation[applicants.length - 2] === jointHolder.jointHolder2RelationShip
        ) {
          return (minCommitmentAmount * jointHolder.minimumAmountPercentage) / 100;
        }
      })
      .filter((ele) => ele)
      .toString();
    return Number(amount);
  }
}

export function applicationDownloadStatusCheck(status: string): boolean {
  return APPLICATION_LISTING_STATUS[status] !== APPLICATION_LISTING_STATUS.completed;
}

export const checkUBOTypeIsTrust = (typeOfUBO: string): boolean => {
  return [UboTypeMaster.notApplicable, UboTypeMaster.indeterminateTrust].includes(
    UboTypeMaster[typeOfUBO]
  );
};

export const isValidPan = (pan: string): boolean =>
  [individualPanRegex, nonIndividualPanRegex].some((pattern) => pattern.test(pan));

export const getArrayLength = (arrayList: number): number[] => {
  return Array.from(
    {
      length: arrayList,
    },
    (value, index) => index + 1
  );
};

export function checkIfApplicationIsNonIndividualPOA(application: ApplicationProps): boolean {
  if (application) {
    const { applicationType, hasPOA } = application;
    return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL && hasPOA;
  } else return false;
}

export const checkInvestorTypeChanged = (applicantion: ApplicationProps | null, value: Values) => {
  const applicationInvestorType = applicantion?.applicants.find(
    (applicant) => applicant.applicant_type?.toString() === '1'
  )?.investorType;
  const valueInvestorType = value.applicants.find(
    (applicant) => applicant.applicant_type?.toString() === '1'
  )?.investorType;
  return (
    ['huf', 'huf_nri'].includes(applicationInvestorType || '') &&
    !['huf', 'huf_nri'].includes(valueInvestorType || '')
  );
};

export const checkKartaUpdated = (
  valuesCoparcenersType: coparcenersType[],
  applicationCoparcenersType: coparcenersType[]
) => {
  const valueKarta = valuesCoparcenersType?.find((_karta) => _karta.karta);
  const applicationKarta = applicationCoparcenersType?.find((_karta) => _karta.karta);
  const valueKartaStr = JSON.stringify(valueKarta);
  const applicationKartaStr = JSON.stringify(applicationKarta);
  return valueKartaStr === applicationKartaStr;
};

export const getAuthorisedSignatoryBasedOnKarta = (coparceners: coparcenersType[]) => {
  const kartaData = coparceners.find((_karta) => _karta.karta);
  return [
    {
      name: 'Group-A',
      threshold: 1,
      isActive: true,
      groupsignatories: [
        {
          name: kartaData?.name || '',
          pan: kartaData?.pan || '',
          mobile: kartaData?.mobile || '',
          countryNameAndCode: kartaData?.countryNameAndCode || '',
          countryCode: kartaData?.countryCode || '',
          email: kartaData?.email || '',
          designation: kartaData?.designation || '',
          canEsign: true,
          isActive: true,
        },
      ],
    },
  ];
};

export function isJson(str: string): boolean {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const checkValidationBasedOnDate = (
  date: string | number | Date,
  validationStartDate: string
): boolean => {
  if (!date) return false;
  const dateForCompare = date ? new Date(date) : new Date();
  const dateForApplyValidations = new Date(validationStartDate);
  return dateForCompare.getTime() >= dateForApplyValidations.getTime();
};

export const checkNriPIO = (status: string, statusSubType: string): boolean => {
  return (
    applicantStatusMasters[status as string] === applicantStatusMasters.NRI &&
    applicantStatusMasters[statusSubType as string] === applicantStatusMasters.NRI_PIO
  );
};

export const checkAllNri = (status: string, statusSubType: string): boolean => {
  return (
    applicantStatusMasters[status as string] === applicantStatusMasters.NRI &&
    [
      applicantStatusMasters.NRI_PIO,
      applicantStatusMasters.NRI_REPATRIABLE,
      applicantStatusMasters.NRI_NON_REPATRIABLE,
      applicantStatusMasters.NRI_OTHERS,
    ].includes(applicantStatusMasters[statusSubType as string])
  );
};

export const checkRepatribleNri = (status: string, statusSubType: string): boolean => {
  return (
    applicantStatusMasters[status as string] === applicantStatusMasters.NRI &&
    [applicantStatusMasters.NRI_REPATRIABLE].includes(
      applicantStatusMasters[statusSubType as string]
    )
  );
};

export const checkNonRepatribleNri = (status: string, statusSubType: string): boolean => {
  return (
    applicantStatusMasters[status as string] === applicantStatusMasters.NRI &&
    [applicantStatusMasters.NRI_NON_REPATRIABLE].includes(
      applicantStatusMasters[statusSubType as string]
    )
  );
};

export const checkOthersNri = (status: string, statusSubType: string): boolean => {
  return (
    applicantStatusMasters[status as string] === applicantStatusMasters.NRI &&
    [applicantStatusMasters.NRI_OTHERS].includes(applicantStatusMasters[statusSubType as string])
  );
};

export const checkNormalNri = (status: string, statusSubType?: string | null): boolean => {
  return applicantStatusMasters[status as string] === applicantStatusMasters.NRI && !statusSubType;
};

export const checkApplicantNri = (status: string): boolean => {
  return status.includes('NRI');
};

export const checkApplicantResident = (status: string): boolean => {
  return applicantStatusMasters[status as string] === applicantStatusMasters.Individual;
};

export const getCountryBasedOnStatus = (
  nationalitiesMdmsResponse: mdmsCountriesList[],
  status: string
): mdmsCountriesList[] => {
  return nationalitiesMdmsResponse.filter((ele) => {
    if (applicantStatusMasters[status] === applicantStatusMasters.NRI_PIO) {
      return !['PK', 'NP', 'AF', 'BD', 'CN', 'IQ', 'BT', 'LK'].includes(ele.code || '');
    }
    return ele;
  });
};

export function hasSIP(sip: string): boolean {
  return YES_NO_MASTER[sip] === SIP_MASTER.yes;
}

export function isAmcCallVerified(amcCallVerified: string): boolean {
  return YES_NO_MASTER[amcCallVerified] === YES_NO_MASTER.no;
}

export function isFirstApplicant(applicant: Partial<Applicant>): boolean {
  return applicant?.applicant_type === '1';
}
export const RTAApproverEnableCheckForIndividual = (): boolean =>
  ENABLE_RTA_APPROVER && AMC_APPROVER_CHECK_FOR_INDIVIDUAL;

export const ApplicationStatusOrClassBasedOnRole = (
  application: ApplicationProps,
  role: USER_ROLES
): string => {
  return application.hasPOA || checkIfApplicationIsNonIndividual(application)
    ? [USER_ROLES.AMCAPPROVER, USER_ROLES.RTAAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
      ? ApplicationStatusBasedOnRole[role][application.status]
      : APPLICATION_LISTING_STATUS[application.status]
    : !checkIfApplicationIsNonIndividual(application) &&
      [USER_ROLES.AMCAPPROVER, USER_ROLES.RTAAPPROVER].includes(role)
    ? IndividualApplicationStatusBasedOnRole[role][application.status]
    : APPLICATION_LISTING_STATUS[application.status];
};

export const MakerOrAdmin = (role: USER_ROLES): boolean =>
  [USER_ROLES.AMC_ADMIN, USER_ROLES.RM, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(
    role
  );

export const RTAApproverLoggedIn = (role: USER_ROLES): boolean => role === USER_ROLES.RTAAPPROVER;
export const AMCApproverLoggedIn = (role: USER_ROLES): boolean => role === USER_ROLES.AMCAPPROVER;

export const Maker = (role: USER_ROLES): boolean =>
  [USER_ROLES.RM, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role);

export const statusRoleBased = (role: USER_ROLES, application: ApplicationProps | null): string => {
  return Maker(role) &&
    (application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ||
      AMC_APPROVER_CHECK_FOR_INDIVIDUAL)
    ? 'draft'
    : application?.status || '';
};

export const isRtaSendBackToMaker = (value?: string): boolean => value === 'maker';

export function isOtherSourceOfFund(sourceOfFunds: string): boolean {
  return !Object.keys(SOURCE_OF_FUNDS_MASTER)
    .filter((item) => item !== 'others')
    .includes(sourceOfFunds);
}

export function isAadhaarSelected(aadhaarOrSsn: string): boolean {
  return AADHAAR_OR_SSN_MASTER[aadhaarOrSsn] === AADHAAR_OR_SSN_MASTER.aadhaar;
}

export function isPassportSelected(passportOrOci: string): boolean {
  return PASSPORT_OR_OCI_MASTER[passportOrOci] === PASSPORT_OR_OCI_MASTER.passport;
}

export const getSideNavComponent = (navOptions: string[]): string[] => {
  return !RiskProfileEnabled
    ? navOptions.filter((e) => !['risk-profiles', 'Risk Profiles'].includes(e))
    : navOptions;
};

export const ShowRiskDoc = (riskDocumentCheck = false): boolean => {
  return RiskProfileEnabled && WishToUploadRiskProfileEnabled && riskDocumentCheck;
};
export const isSchemeNIDI2 = (mdmsProfile: RiskProfileMasterType, schemeId: string): boolean => {
  return ['retirement', 'dependentIncome'].includes(mdmsProfile?.key) && schemeId === '3';
};

export const getRiskProfileQues = (
  response: RiskProfileMaster,
  schemeId: number | string | undefined,
  applicationType: string | undefined
): RiskProfileMasterType[] => {
  const dataBasedOnScheme = (response as any)[
    `riskProfile_scheme${Number(schemeId)}`
  ] as RiskProfileMasterType[];
  return (dataBasedOnScheme?.length ? [...response.riskProfile_common, ...dataBasedOnScheme] : [])
    .filter((mdmsProfile) => {
      if (
        isSchemeNIDI2(mdmsProfile, schemeId?.toString() || '') &&
        applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
      ) {
        return;
      } else return mdmsProfile;
    })
    .filter((mdmsProfile) => mdmsProfile)
    .map((mdmsProfile) => {
      return {
        ...mdmsProfile,
        displayText: isSchemeNIDI2(mdmsProfile, schemeId?.toString() || '')
          ? 'If Individual Investor: ' + mdmsProfile.displayText
          : mdmsProfile.displayText,
        required: ['retirement', 'dependentIncome'].includes(mdmsProfile?.key)
          ? 'true'
          : mdmsProfile?.required,
      };
    });
};

export const checkQuestionPresent = (
  schemeId: number | string | undefined,
  RiskData: RiskProfileMasterType[]
): boolean => {
  return !!schemeId && RiskData.length === 0;
};

export const isGetLinkVisible = (status: string): boolean =>
  ![
    'draft',
    'rejected',
    'sent_to_poa_approver',
    'sent_to_amc_approver',
    'sent_to_rta_approver',
  ].includes(status);

export const displaySendBack = (application: ApplicationProps): string => {
  return application.applicationSentBack ||
    (application.rtaSentBack &&
      APPLICATION_LISTING_STATUS[application.status] ===
        APPLICATION_LISTING_STATUS.sent_to_amc_approver)
    ? ' (Send Back)'
    : '';
};

export const fatcaDocumentCheck = (fatcaDocument: boolean, docType: string): boolean => {
  return fatcaDocument && docType === 'fatca';
};

export function isNEFT(modeOfPayment: string): boolean {
  return MODE_OF_PAYMENT_MASTER.neft === MODE_OF_PAYMENT_MASTER[modeOfPayment];
}

export function isChequeOrRTGS(modeOfPayment: string): boolean {
  return [MODE_OF_PAYMENT_MASTER.cheque, MODE_OF_PAYMENT_MASTER.rtgs].includes(
    MODE_OF_PAYMENT_MASTER[modeOfPayment]
  );
}

export const isUboTypeIndividual = (uboType: string): boolean => {
  return UboCategoryMaster.individual === UboCategoryMaster[uboType];
};

export const isUboTypeNonIndividual = (uboType: string): boolean => {
  return UboCategoryMaster.non_individual === UboCategoryMaster[uboType];
};

export const isValidPEP = (pepStatus: string): boolean => {
  return ['I am PEP', 'I am Related to PEP'].includes(pepStatus);
};

export const isDrawnOnBankSameAsInvestorBank = (
  investorBankAccNo: string,
  drawnOnBankAccNo: string
): boolean => {
  return investorBankAccNo === drawnOnBankAccNo;
};

export const getAccNumberFromDefaultAcc = (application: ApplicationProps): string => {
  return application?.banks?.find((bank) => bank.defaultBankAccount)?.bankAccountNumber || '';
};

export const getPanAadhaarMasterBasedOnstatus = (
  panAadhaarMaster: string[],
  status: string
): string[] => {
  return checkApplicantResident(status)
    ? panAadhaarMaster.filter((item) => PAN_AADHAAR_MASTER[item] !== PAN_AADHAAR_MASTER.exemption)
    : panAadhaarMaster;
};

export const getOverseasCountryIfExist = (applicant: Partial<Applicant>): string => {
  return applicant.addresses?.find((address) => address.address_type === 'overseas')?.country || '';
};

export const isBankAccountProof = (documentType: string): boolean =>
  documentType === 'bankAccountProof';
export const isDocTypeCheque = (documentName: string): boolean =>
  documentName === 'Cancelled cheque leaf verified';

export const isSentForAMCClearance = (role: USER_ROLES, status: string) =>
  AMCApproverLoggedIn(role) &&
  APPLICATION_LISTING_STATUS[status] === APPLICATION_LISTING_STATUS.sent_for_amc_clearance;

export const isSentToApplicant1 = (application: ApplicationProps) =>
  !application?.hasPOA &&
  (sendApplication_Nri(application) ||
    (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && !checkIfApplicationIsNonIndividual(application)));

export const isAMCAdminLogin = (role: string): boolean => USER_ROLES.AMC_ADMIN === role;

/**
 * temprary solution for https://webileapps.atlassian.net/browse/ADO-2106
 * functionality will work like
 * if there is no list for mobilenumbers menu will be visible to all amc admin, otherwise to releted person only
 */
export const isAdminMenuVisible = (mobile: string): visiblityAccessTypes => {
  const mobileNumbersforDashboardAccess: string[] = [];
  const mobileNumbersforReportAccess: string[] = [];
  const mobileNumbersforApplicationAccess: string[] = [
    '9295501996',
    '9849593474',
    '9989645001',
    '8655983283',
  ];
  const mobileNumbersforUsermanegementAccess: string[] = [
    '9295501996',
    '9849593474',
    '9989645001',
    '8655983283',
  ];
  const mobileNumbersforFundAccess: string[] = [
    '9295501996',
    '9849593474',
    '9989645001',
    '8655983283',
  ];
  return {
    applicationAccess: mobileNumbersforApplicationAccess.length
      ? mobileNumbersforApplicationAccess.includes(mobile.toString())
      : true,
    reportAccess: mobileNumbersforReportAccess.length
      ? mobileNumbersforReportAccess.includes(mobile.toString())
      : true,
    userManagementAccess: mobileNumbersforUsermanegementAccess.length
      ? mobileNumbersforUsermanegementAccess.includes(mobile.toString())
      : true,
    dashboardAccess: mobileNumbersforDashboardAccess.length
      ? mobileNumbersforDashboardAccess.includes(mobile.toString())
      : true,
    fundAccess: mobileNumbersforFundAccess.length
      ? mobileNumbersforFundAccess.includes(mobile.toString())
      : true,
  };
};
export function isCkycMandatory(ckycOption: string): boolean {
  return CKYC_SELECTION_OPTIONS_OBJECT[ckycOption] === CKYC_SELECTION_OPTIONS_OBJECT.yes;
}

export const isSchemeNICO = (schemeCode: string): boolean => {
  return schemeCode?.toUpperCase() === 'CO';
};

export const individualApplicantsDocuments = (
  application: ApplicationProps | null,
  documentsData: Document | undefined,
  role: USER_ROLES
): documentProps[] => {
  const { applicants = [], banks = [], hasPOA = true, nominees = [], scheme } = application || {};
  return applicants.map((applicant, applicant_index) => {
    let docData = '';
    if (
      !hasPOA &&
      applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
    ) {
      if (
        onboardingTypeMasters[applicants[0].onboardingType as string] ===
        onboardingTypeMasters.minor
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.MINOR;
      } else {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL;
      }
    }
    if (
      hasPOA &&
      applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
    ) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL_POA;
    }
    if (!hasPOA && checkNormalNri(applicant.status as string, applicant.statusSubType)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI;
    }
    if (hasPOA && checkNormalNri(applicant.status as string, applicant.statusSubType)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA;
    }
    if (!hasPOA && checkNriPIO(applicant.status as string, applicant.statusSubType as string)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_PIO;
    }
    if (hasPOA && checkNriPIO(applicant.status as string, applicant.statusSubType as string)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA_PIO;
    }

    if (
      !hasPOA &&
      checkRepatribleNri(applicant.status as string, applicant.statusSubType as string)
    ) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_REPATRIABLE;
    }
    if (
      hasPOA &&
      checkRepatribleNri(applicant.status as string, applicant.statusSubType as string)
    ) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_REPATRIABLE_POA;
    }

    if (
      !hasPOA &&
      checkNonRepatribleNri(applicant.status as string, applicant.statusSubType as string)
    ) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_NON_REPATRIABLE;
    }
    if (
      hasPOA &&
      checkNonRepatribleNri(applicant.status as string, applicant.statusSubType as string)
    ) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_NON_REPATRIABLE_POA;
    }

    if (!hasPOA && checkOthersNri(applicant.status as string, applicant.statusSubType as string)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_OTHERS;
    }
    if (hasPOA && checkOthersNri(applicant.status as string, applicant.statusSubType as string)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_OTHERS_POA;
    }
    return {
      documents:
        typeof documentsData !== 'undefined'
          ? ((documentsData as Document)[docData] || [])
              .filter((doc) => {
                if (
                  hasPOA &&
                  applicant.applicant_type !== '1' &&
                  doc.documentType === 'poaNotarized'
                ) {
                  return;
                }
                if (
                  isNaturalParent[applicant.naturalParent as string] !== isNaturalParent.no &&
                  doc.documentType === 'proofOfCourt'
                ) {
                  return;
                }
                if (
                  !ShowRiskDoc(applicant?.riskDocumentCheck as boolean) &&
                  doc.documentType === 'riskForm'
                ) {
                  return;
                }
                if (
                  isCkycMandatory(applicant?.ckyc_selection_options || '') &&
                  doc.documentType === 'ckyc_document'
                ) {
                  return;
                }
                if (
                  !isValidPEP(applicant.politicallyExposedPersonStatus || '') &&
                  doc.documentType === 'pep_document'
                ) {
                  return;
                }
                if (
                  !cleardpIdField(applicant.dlclId || '') &&
                  doc.documentType === 'document_for_demat'
                ) {
                  return;
                }
                if (
                  isDrawnOnBankSameAsInvestorBank(
                    getAccNumberFromDefaultAcc(application as ApplicationProps),
                    application?.drawnAccountNumber || ''
                  ) &&
                  doc.documentType === 'drawn_on_bank'
                ) {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((_doc) => {
                if (role === USER_ROLES.POAAPPROVER && _doc.documentType === 'poaNotarized') {
                  return { ..._doc, required: 'true' };
                }
                if (
                  isNaturalParent[applicant.naturalParent as string] === isNaturalParent.no &&
                  _doc.documentType === 'proofOfCourt'
                ) {
                  return { ..._doc, required: 'true' };
                }
                if (
                  ShowRiskDoc(applicant?.riskDocumentCheck as boolean) &&
                  _doc.documentType === 'riskForm'
                ) {
                  return { ..._doc, required: 'true' };
                }
                if (
                  !isCkycMandatory(applicant?.ckyc_selection_options || '') &&
                  _doc.documentType === 'ckyc_document'
                ) {
                  return { ..._doc, required: 'true' };
                }
                if (
                  isValidPEP(applicant.politicallyExposedPersonStatus || '') &&
                  _doc.documentType === 'pep_document'
                ) {
                  return { ..._doc, required: 'true' };
                }
                if (
                  cleardpIdField(applicant.dlclId || '') &&
                  _doc.documentType === 'document_for_demat'
                ) {
                  return { ..._doc, required: 'true' };
                }
                if (
                  !isDrawnOnBankSameAsInvestorBank(
                    getAccNumberFromDefaultAcc(application as ApplicationProps),
                    application?.drawnAccountNumber || ''
                  ) &&
                  _doc.documentType === 'drawn_on_bank'
                ) {
                  return { ..._doc, required: 'true' };
                }
                return _doc;
              })
              .filter((document) => {
                if (applicant.amlCheck && document.documentType === 'compliance_document') {
                  return;
                }
                if (
                  !(Number(applicant.age) > 65) &&
                  document.documentType === 'senior_citizen_document'
                ) {
                  return;
                }

                if (
                  (!isFirstApplicant(applicant) ||
                    !isAmcCallVerified(applicant.amcCallVerified || '')) &&
                  document.documentType === 'amc_verification_document'
                ) {
                  return;
                }

                if (
                  (!isFirstApplicant(applicant) ||
                    !checkSip([application?.modeOfInvestment || ''])) &&
                  document.documentType === 'otbm_document'
                ) {
                  return;
                }

                return document;
              })
              .filter((ele) => ele)
              .filter((doc) => {
                if (
                  !applicant.correspondenceAddressEdited &&
                  doc.documentType === 'correspondenceAddress'
                ) {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((doc) => {
                if (
                  applicant.correspondenceAddressEdited &&
                  doc.documentType === 'correspondenceAddress'
                ) {
                  return { ...doc, required: 'true' };
                }
                if (Number(applicant.age) > 65 && doc.documentType === 'senior_citizen_document') {
                  return { ...doc, required: 'true' };
                }

                if (
                  isFirstApplicant(applicant) &&
                  isAmcCallVerified(applicant.amcCallVerified || '') &&
                  doc.documentType === 'amc_verification_document'
                ) {
                  return { ...doc, required: 'true' };
                }

                if (
                  isFirstApplicant(applicant) &&
                  checkSip([application?.modeOfInvestment || '']) &&
                  doc.documentType === 'otbm_document'
                ) {
                  return { ...doc, required: 'true' };
                }

                if (
                  isSchemeNICO(scheme?.schemeCode || '') &&
                  doc.documentType === 'temporary_residence_certificate'
                ) {
                  return { ...doc, required: 'true' };
                }

                return doc;
              })
              .map((_doc) => {
                if (
                  applicant?.dlclId &&
                  !cleardpIdField(applicant?.dlclId || '') &&
                  _doc.documentType === 'demat_information'
                ) {
                  return { ..._doc, required: 'true' };
                }
                return _doc;
              })
              .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                const { documentType, documentName, multipleFiles, required, options } = doc;
                const { documents: existingDocuments = [] } = applicant || {};
                const docsOfCurrentDocType = existingDocuments
                  .filter((doc) => doc.documentType === documentType)
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                return {
                  documentType: documentType,
                  documentName: documentName,
                  documentsList: docsOfCurrentDocType.length
                    ? docsOfCurrentDocType.map((doc, ind) => {
                        const {
                          id,
                          documentName = '',
                          documentType = '',
                          documentId = '',
                          isActive = true,
                          file = undefined,
                          chequeIssuingDate = null,
                        } = doc;
                        return {
                          id,
                          applicantId: applicant?.id,
                          documentType,
                          documentName,
                          documentId,
                          isActive,
                          file,
                          chequeIssuingDate,
                          options,
                          required,
                          uniqueKey: (applicant_index.toString() +
                            '-' +
                            index.toString() +
                            '-' +
                            ind.toString()) as string,
                          errorOnUpload: document_object.errorOnUpload,
                        };
                      })
                    : [
                        {
                          documentType,
                          documentName,
                          required,
                          options,
                          chequeIssuingDate: null,
                          uniqueKey: (applicant_index.toString() +
                            '-' +
                            index.toString() +
                            '-' +
                            '0') as string,
                          ...document_object,
                        },
                      ],
                  required,
                  multipleFiles,
                  options,
                };
              })
          : [],
      kraDocument: applicant.kraDocument,
    };
  });
};

export const NonIndividualApplicantDocuments = (
  application: ApplicationProps | null,
  documentsData: individuals_Poa_nonIndividuals_Documents[],
  role: USER_ROLES
) => {
  const { applicants = [], banks = [] } = application || {};
  return applicants.map((applicant, applicant_index) => {
    return {
      documents: documentsData
        .filter((doc) => {
          if (
            checkIfApplicationIsNonIndividualPOA(application as ApplicationProps) &&
            applicant.applicant_type !== '1' &&
            doc.documentType === 'poaNotarized'
          ) {
            return;
          }
          if (
            !ShowRiskDoc(applicant?.riskDocumentCheck as boolean) &&
            doc.documentType === 'riskForm'
          ) {
            return;
          }
          if (
            fatcaDocumentCheck(!applicant.wishToUploadFatcaDocument as boolean, doc.documentType)
          ) {
            return;
          }
          if (
            isCkycMandatory(applicant?.ckyc_selection_options || '') &&
            doc.documentType === 'ckyc_document'
          ) {
            return;
          }
          if (
            !isValidPEP(applicant.politicallyExposedPersonStatus || '') &&
            doc.documentType === 'pep_document'
          ) {
            return;
          }
          if (
            !cleardpIdField(applicant.dlclId || '') &&
            doc.documentType === 'document_for_demat'
          ) {
            return;
          }
          if (
            isDrawnOnBankSameAsInvestorBank(
              getAccNumberFromDefaultAcc(application as ApplicationProps),
              application?.drawnAccountNumber || ''
            ) &&
            doc.documentType === 'drawn_on_bank'
          ) {
            return;
          }
          return doc;
        })
        .filter((ele) => ele)
        .map((_doc) => {
          if (role === USER_ROLES.POAAPPROVER && _doc.documentType === 'poaNotarized') {
            return { ..._doc, required: 'true' };
          }
          if (
            ShowRiskDoc(applicant?.riskDocumentCheck as boolean) &&
            _doc.documentType === 'riskForm'
          ) {
            return { ..._doc, required: 'true' };
          }
          if (
            fatcaDocumentCheck(applicant.wishToUploadFatcaDocument as boolean, _doc.documentType)
          ) {
            return { ..._doc, required: 'true' };
          }
          if (
            !isCkycMandatory(applicant?.ckyc_selection_options || '') &&
            _doc.documentType === 'ckyc_document'
          ) {
            return { ..._doc, required: 'true' };
          }
          if (
            isValidPEP(applicant.politicallyExposedPersonStatus || '') &&
            _doc.documentType === 'pep_document'
          ) {
            return { ..._doc, required: 'true' };
          }
          if (
            cleardpIdField(applicant.dlclId || '') &&
            _doc.documentType === 'document_for_demat'
          ) {
            return { ..._doc, required: 'true' };
          }
          if (
            !isDrawnOnBankSameAsInvestorBank(
              getAccNumberFromDefaultAcc(application as ApplicationProps),
              application?.drawnAccountNumber || ''
            ) &&
            _doc.documentType === 'drawn_on_bank'
          ) {
            return { ..._doc, required: 'true' };
          }
          return _doc;
        })
        .filter((document) => {
          if (applicant.amlCheck && document.documentType === 'compliance_document') {
            return;
          }
          if (
            !isAmcCallVerified(applicant.amcCallVerified || '') &&
            document.documentType === 'amc_verification_document'
          ) {
            return;
          }

          if (
            !checkSip([application?.modeOfInvestment || '']) &&
            document.documentType === 'otbm_document'
          ) {
            return;
          }
          return document;
        })
        .filter((ele) => ele)
        // .filter((doc) => {
        //   if (
        //     !applicant.correspondenceAddressEdited &&
        //     doc.documentType === 'correspondenceAddress'
        //   ) {
        //     return;
        //   }
        //   return doc;
        // })
        // .filter((ele) => ele)
        // .map((doc) => {
        //   if (
        //     applicant.correspondenceAddressEdited &&
        //     doc.documentType === 'correspondenceAddress'
        //   ) {
        //     return { ...doc, required: 'true' };
        //   }
        //   return doc;
        // })
        .map((_doc) => {
          if (
            applicant?.dlclId &&
            !cleardpIdField(applicant?.dlclId || '') &&
            _doc.documentType === 'demat_information'
          ) {
            return { ..._doc, required: 'true' };
          }
          if (
            isAmcCallVerified(applicant.amcCallVerified || '') &&
            _doc.documentType === 'amc_verification_document'
          ) {
            return { ..._doc, required: 'true' };
          }

          if (
            checkSip([application?.modeOfInvestment || '']) &&
            _doc.documentType === 'otbm_document'
          ) {
            return { ..._doc, required: 'true' };
          }
          return _doc;
        })
        .map((doc, index) => {
          const { documentType, documentName, multipleFiles, required, options, downloadTemplate } =
            doc;
          const { documents: existingDocuments = [] } = applicant || {};
          const docsOfCurrentDocType = existingDocuments
            .filter((doc) => doc.documentType === documentType)
            .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
          return {
            documentType: documentType,
            documentName: documentName,
            documentsList: docsOfCurrentDocType.length
              ? docsOfCurrentDocType.map((doc, ind) => {
                  const {
                    id,
                    documentName = '',
                    documentType = '',
                    documentId = '',
                    isActive = true,
                    file = undefined,
                    chequeIssuingDate = null,
                  } = doc;
                  return {
                    id,
                    applicantId: applicant?.id,
                    documentType,
                    documentName,
                    documentId,
                    isActive,
                    file,
                    chequeIssuingDate,
                    options,
                    required,
                    downloadTemplate,
                    uniqueKey: (applicant_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      ind.toString()) as string,
                    errorOnUpload: document_object.errorOnUpload,
                  };
                })
              : [
                  {
                    documentType,
                    documentName,
                    required,
                    options,
                    chequeIssuingDate: null,
                    downloadTemplate,
                    uniqueKey: (applicant_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      '0') as string,
                    ...document_object,
                  },
                ],
            required,
            multipleFiles,
            options,
            downloadTemplate,
          };
        }),
      kraDocument: applicant.kraDocument,
      wishToUploadFatcaDocument: applicant.wishToUploadFatcaDocument,
    };
  });
};

export const getApplicantStatus = (applicantType: string): string[] => {
  switch (applicantType) {
    case '1':
      return ['Individual', 'NRI_PIO', 'NRI_REPATRIABLE', 'NRI_NON_REPATRIABLE'];
    default:
      return ['Individual', 'NRI_OTHERS'];
  }
};

export const dlclIdFieldMandatory = (): boolean => {
  return checkValidationBasedOnDate(new Date(), dlclIdFieldValidationDate);
};

const isCountryOrNationalityExist = (countryOrNationality: string): boolean => {
  return NRI_DECLARATION_COUNTRIES.map((country) => country?.toUpperCase())?.includes(
    countryOrNationality?.toUpperCase()
  );
};
export const eSignDeclarationCheck = (
  applicant: Partial<Applicant>,
  createdDate: string
): boolean => {
  const addressCountry = applicant.addresses?.reduce((obj, item) => {
    return { ...obj, [item.address_type as string]: item.country };
  }, {}) as { permanent: string; overseas: string };
  const {
    nationality = '',
    countryOfBirth = '',
    countryOfNationality = '',
    taxCountryName = '',
    status = '',
  } = applicant;
  return (
    (isCountryOrNationalityExist(nationality) ||
      isCountryOrNationalityExist(addressCountry.permanent) ||
      isCountryOrNationalityExist(addressCountry.overseas) ||
      isCountryOrNationalityExist(countryOfBirth) ||
      isCountryOrNationalityExist(countryOfNationality) ||
      isCountryOrNationalityExist(taxCountryName)) &&
    checkApplicantNri(status) &&
    checkValidationBasedOnDate(createdDate, nriDeclarationStartDate)
  );
};

/**
 * Calculates the age between two given dates.
 *
 * @param _birthDate - The birth date in 'YYYY-MM-DD' format.
 * @param _otherDate - The other date in 'YYYY-MM-DD' format.
 * @returns The age in years between the two dates.
 *
 * @remarks
 * This function takes two dates as input, converts them into JavaScript Date objects,
 * and calculates the difference in years between them. It accounts for the possibility
 * that the other date might be before the birth date.
 */
export function calculateAge(_birthDate: string | Date, _otherDate: string): number {
  const birthDate = new Date(_birthDate);
  const otherDate = new Date(_otherDate);

  let years = otherDate.getFullYear() - birthDate.getFullYear();

  if (
    otherDate.getMonth() < birthDate.getMonth() ||
    (otherDate.getMonth() == birthDate.getMonth() && otherDate.getDate() < birthDate.getDate())
  ) {
    years--;
  }

  return years;
}

export const handleDownload = async (fileUrl: string, fileName: string): Promise<void> => {
  // Fetch the file data

  const newOrigin = window.location.origin; // Get the current page's origin
  const url = new URL(fileUrl);

  // Construct the updated URL using the pathname and search
  const updatedUrl = `${newOrigin}${url.pathname}${url.search}`;

  const response = await fetch(updatedUrl);
  if (!response.ok) {
    throw new Error(en.networkText.unableToProcess);
  }
  const blob = (await response.blob()) as Blob;

  // Create a URL for the blob
  const blobUrl = URL.createObjectURL(blob);

  // Create an anchor element and trigger the download
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  // Clean up
  link.remove();
  URL.revokeObjectURL(blobUrl);
};

export const getGrossAnnualMasters = (createdAt: string): string[] =>
  checkValidationBasedOnDate(createdAt, changeGrossAnnualMastersDate)
    ? newGrossAnnualMasters
    : oldGrossAnnualMasters;

export const checkforDirectInvestment = (
  applicationCreatedAt: string,
  distributorName: string
): boolean => {
  return (
    !checkValidationBasedOnDate(applicationCreatedAt, directInvestmentDisabledDate) ||
    !distributorName
  );
};

export const isOtherOccupation = (occupation: string): boolean => {
  return occupation.toUpperCase() === 'OTHERS';
};

export const getInvestorTypeMasters = (
  applicationDate: string | Date
): { [key: string]: string } => {
  const isNew = checkValidationBasedOnDate(applicationDate, partnershipFirmLabelChangeDate);
  const dynamicLabel = isNew ? 'Partnership Firm' : 'Partnership Firm/ LLP';

  return {
    ...investorTypeMasters,
    partnership_firm: dynamicLabel,
  };
};

export const isOtherTypeOfInvestor = (investorType: string): boolean => {
  return investorTypeMasters[investorType] === investorTypeMasters.other_private_ltd_co;
};

export function isFieldApplicable(value: string): boolean {
  return YES_NO_MASTER[value?.toLowerCase()] === YES_NO_MASTER.yes;
}

export function isFieldVariable(FeeTypeValue: string | null, fieldApplicable: string): boolean {
  return (
    FEE_TYPE_MASTER[FeeTypeValue?.toLowerCase() || ''] === FEE_TYPE_MASTER.variable &&
    YES_NO_MASTER[fieldApplicable?.toLowerCase()] === YES_NO_MASTER.yes
  );
}
